export default __webpack_public_path__ + "static/media/everylive-QRcode-google-play.6169c64b.png";